import { FacebookCustomEvent, FacebookPageViewEvent, FacebookSearchEvent } from './facebook';
import {
  FirebaseCustomEvent,
  FirebasePageViewEvent,
  FirebaseScreenViewEvent,
  FirebaseViewSearchResultsEvent,
} from './firebase';
import { hasNativeAnalytics } from './nativeFirebase';

export class LoggingAnalyticsHandler {
  trackEvent(url) {
    //console.log('Analytics page view:', url);
  }
}

export class GoogleTrackingEventHandler {
  trackEvent(url, store, routeName) {
    const { previousLocation } = store.getState().routing;

    const urlObj = new URL(process.env.REACT_APP_CANONICAL_ROOT_URL + url);
    const { search } = urlObj;

    if (hasNativeAnalytics()) {
      // App streams report screens, not pages — screen_view is the native
      // counterpart of page_view (page_view stays web-only).
      FirebaseScreenViewEvent.withScreenName(routeName || url)
        .withPageLocation(url)
        .withPageReferer(previousLocation)
        .logEvent();
    } else {
      FirebasePageViewEvent.withPageLocation(url).withPageReferer(previousLocation).logEvent();
    }
    if (routeName === 'SearchPage') {
      const searchParams = new URLSearchParams(search);
      const address = searchParams.get('address');
      searchParams.delete('address');
      let additionalKeys = [];
      for (const key of searchParams.keys()) {
        additionalKeys.push({ key, value: searchParams.get(key) });
      }
      FirebaseViewSearchResultsEvent.withSearchTerm(address)
        .withAdditionalKeys(additionalKeys)
        .logEvent();
    }

    const searchParams = new URLSearchParams(search);
    if (searchParams.has('event')) {
      const urlParamEvent = JSON.parse(window.atob(searchParams.get('event') || ''));
      FirebaseCustomEvent.withCustomName(urlParamEvent.name)
        .withParams(urlParamEvent.params)
        .logEvent();
    }
  }
}

export class FacebookTrackingEventHandler {
  trackEvent(url, store, routeName) {
    const urlObj = new URL(process.env.REACT_APP_CANONICAL_ROOT_URL + url);
    const { search } = urlObj;
    const { currentUser } = store.getState().user;

    FacebookPageViewEvent.withCurrentUserUUID(currentUser?.id?.uuid).logEvent();

    if (routeName === 'SearchPage') {
      FacebookSearchEvent.withCurrentUserUUID(currentUser?.id?.uuid)
        .withSearchString(search)
        .logEvent();
    }

    const searchParams = new URLSearchParams(search);
    if (searchParams.has('event')) {
      const urlParamEvent = JSON.parse(window.atob(searchParams.get('event') || ''));
      FacebookCustomEvent.withCurrentUserUUID(currentUser?.id?.uuid)
        .withCustomName(urlParamEvent.name)
        .withParams(urlParamEvent.params)
        .logEvent();
    }
  }
}
